module.exports = function getResource(label, vars = []) {
    const resources = {
        uncheckJoinErrorMessage: `Vous devez accepter les conditions générales du programme Beauty Insider afin de pouvoir accumuler ${vars[0]} points sur vos achats du jour.`,
        popoverContent: `Inscrivez-vous à Beauty Insider pour économiser ${vars[0]} points sur votre achat. Obtenez des expériences uniques, des services personnalisés et des échantillons convoités.`,
        linkActionText: 'Voir les récompenses actuelles',
        dontForgetText: `N’oubliez pas d’économiser vos ${vars[0]} points!`,
        testDontForgetText: `Envie d’économiser vos ${vars[0]} points?`,
        testBankThemText: 'Accumulez-les et profitez de nombreux avantages en adhérant à Beauty Insider, notre programme de fidélisation GRATUIT.',
        testNewBiPropFree: 'Gratuit',
        testNewBiPropBDayGift: 'Cadeau d’anniversaire',
        testNewBiPropFreeGift: 'Cadeau d’anniversaire gratuit',
        testNewBiPropPoints: 'Économies saisonnières',
        testNewBiPropRedeem: 'Échantillons de récompenses',
        testJoinNowButton: 'S’inscrire',
        testLegalClickingText: 'En cliquant sur « S’inscrire », vous reconnaissez être résident du Canada ou des États-Unis, vous acceptez la',
        testLegalPrivacyPolicyLink: 'politique de confidentialité de Sephora,',
        testLegalTermsOfUseLink: 'Conditions d’utilisation',
        testLegalBiTermsLink: 'modalités Beauty Insider',
        testLegalAutomaticallyText: ', et vous acceptez de recevoir automatiquement les offres Beauty Insider par courriel.',
        testEnterPasswordToCreateText: `Créez un mot de passe pour ${vars[0]}`,
        enterPasswordToSaveText: 'Entrez votre mot de passe Sephora',
        enterPasswordToSaveDetailsText: `pour ${vars[0]} économiser vos ${vars[1]} points sur cet achat.`,
        enterPasswordToCreateText: 'Entrez un mot de passe pour créer votre compte.',
        passwordInputLabel: `Mot de passe (${vars[0]} à ${vars[1]} caractères)*`,
        forgotText: 'Mot de passe oublié?',
        savePointsButton: 'Économiser des points',
        createAccountButton: 'Créer un compte',
        thankYouText: 'Merci pour votre inscription!',
        browseBazaarText: 'Votre commande apparaîtra dans votre historique des commandes Jeter un coup d’œil à la foire aux récompenses Rewards Bazaar.',
        viewBazaarText: 'Consulter la foire aux récompenses'
    };

    return resources[label];
};
